// Zimmet durumları (API dokümanına göre)
export enum AssetStatus {
  IN_STOCK = 'IN_STOCK',      // Envanterde, atanmaya hazır
  ASSIGNED = 'ASSIGNED',      // Bir çalışana zimmetlenmiş
  SCRAPPED = 'SCRAPPED'       // Hurdaya ayrılmış, kullanılamaz
}

// Dosya bilgisi (API dokümanına göre)
export interface AssetFile {
  path: string;
  fileName: string;
  mimeType: string;
  size: number;
}

// Zimmet (Asset) temel tipi (API dokümanına göre)
export interface Asset {
  id: number;
  name: string;
  serialNumber: string;
  files: AssetFile[];
  status: AssetStatus;
  userId: number | null;
  user: {
    id: number;
    firstName: string;
    lastName: string;
    email?: string;
  } | null;
  createdAt: string;
  updatedAt: string;
}

// Yeni zimmet oluşturma için request tipi (Envantere ekle)
export interface CreateAssetRequest {
  name: string;
  serialNumber: string;
  files?: File[]; // Dosya yüklemesi için
}

// Zimmeti çalışana atama için request tipi
export interface AssignAssetRequest {
  userId: number;
}

// Zimmet bilgilerini güncelleme için request tipi
export interface UpdateAssetRequest {
  name: string;
  serialNumber: string;
  status?: AssetStatus; // Durum güncellemesi için opsiyonel
}

// Zimmet durumu güncelleme için request tipi
export interface UpdateAssetStatusRequest {
  status: AssetStatus;
}

// API response tipleri (API dokümanına göre)
export interface AssetResponse {
  code: number;
  data: Asset;
  message: string;
}

export interface AssetsResponse {
  code: number;
  data: Asset[];
  message: string;
}

// Zimmet listesi için filtre tipi
export interface AssetFilters {
  userId?: number;
  status?: AssetStatus;
  search?: string;
}



// Zimmet form verisi tipi
export interface AssetFormData {
  name: string;
  serialNumber: string;
  files?: FileList;
}

// Zimmet atama form verisi tipi
export interface AssetAssignFormData {
  userId: number;
}

// Zimmet tablosu için kolon tipi
export interface AssetTableColumn {
  key: string;
  label: string;
  sortable?: boolean;
  width?: string;
}

// Zimmet oluşturma modal props
export interface CreateAssetModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  isLoading?: boolean;
}

// Zimmet atama modal props
export interface AssignAssetModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  asset: Asset | null;
  employees: { id: number; firstName: string; lastName: string; email: string }[];
  availableAssets?: Asset[]; // Çalışan detay sayfası için envanterdeki zimmetler
  isLoading?: boolean;
}

// Zimmet bilgi güncelleme modal props
export interface EditAssetModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  asset: Asset | null;
  isLoading?: boolean;
}

// Zimmet durum güncelleme modal props
export interface UpdateAssetModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  asset: Asset | null;
  isLoading?: boolean;
}

// Zimmet detay sayfası için props
export interface AssetDetailProps {
  assetId: number;
}

// Çalışan zimmet listesi için props
export interface EmployeeAssetListProps {
  userId: number;
  userName?: string;
  showActions?: boolean;
  compact?: boolean;
}

// API Error tipi
export interface AssetError {
  success: false;
  message: string;
  error?: string;
} 